import { AlertService } from "src/app/share/service/alert.service";
import { FormGroup } from "@angular/forms";
import { Component, Inject } from "@angular/core";
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA
} from "@angular/material/bottom-sheet";
import { PromoCodeMotorService } from "../../motor/services/promo-code-motor.service";
import { PromoCodeDealerService } from "../../dealer/services/promo-code-dealer.service";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.scss"]
})
export class UploadFileComponent {
  frmGroup: FormGroup;
  errorMessage: string = "";
  partnerGroupData: any;
  uploadedFile: any;
  partnerGroupList: any[] = [];

  constructor(
    private alertService: AlertService,
    private promoCodeMotorService: PromoCodeMotorService,
    private promoCodeDealerService: PromoCodeDealerService,
    private bottomSheetRef: MatBottomSheetRef<UploadFileComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    private data: {
      type: string;
    }
  ) {}

  deleteFile() {
    this.uploadedFile = null;
  }

  fileChangeEvent(e) {
    if (e.target.files && e.target.files[0]) {
      const file: File = e.target.files[0];

      // Check if the file type is Excel (.xlsx or .xls)
      const allowedTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ];
      if (!allowedTypes.includes(file.type)) {
        this.alertService.openSnackBar("Only Excel files are allowed.");
        return;
      }

      this.uploadedFile = file;
    }
    e.target.value = "";
  }

  close(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  onUpload() {
    const formData = new FormData();
    formData.append("File", this.uploadedFile);
    let serviceType;

    if (this.data.type === "motor") {
      serviceType = this.promoCodeMotorService;
    } else {
      serviceType = this.promoCodeDealerService;
    }
    serviceType.uploadExcel(formData).subscribe(
      (x) => {
        if (x.size != 0) {
          let dataType = x.type;
          let binaryData = [];
          binaryData.push(x);
          let downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(
            new Blob(binaryData, { type: dataType })
          );
          downloadLink.setAttribute("download", "error");

          document.body.appendChild(downloadLink);
          downloadLink.click();
        } else {
          this.alertService.openSnackBar("File uploaded successfully.");
        }
        this.uploadedFile = null;

        this.bottomSheetRef.dismiss({ success: true });
      },
      (error) => {
        console.error("Error uploading file:", error);
        this.alertService.openSnackBar("Error uploading file.");
      }
    );
  }
}
